import { render, staticRenderFns } from "./FavCities.vue?vue&type=template&id=0bd80f1c&scoped=true"
import script from "./FavCities.vue?vue&type=script&lang=js"
export * from "./FavCities.vue?vue&type=script&lang=js"
import style0 from "./FavCities.vue?vue&type=style&index=0&id=0bd80f1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd80f1c",
  null
  
)

export default component.exports